import { Comments } from 'components/Comments';

import { actions, recruitmentStatusByCode } from 'entities';

import { useRecruitmentModal } from './context';

export function RecruitmentComments() {
  const { recruitment, updateRecruitment } = useRecruitmentModal();

  const createComment = actions.projects.createRecruitmentComment.use({
    onSuccess: (comment) =>
      updateRecruitment((old) => ({
        ...old,
        comments: [comment, ...old.comments],
        commentCount: (old.commentCount ?? 0) + 1,
      })),
  });

  const editComment = actions.projects.editRecruitmentComment.use({
    onSuccess: (comment) =>
      updateRecruitment((old) => ({
        ...old,
        comments: old.comments.map((c) => (c.timestamp === comment.timestamp ? comment : c)),
      })),
  });

  return (
    <Comments
      canEdit={recruitmentStatusByCode[recruitment!.status].canComment}
      comments={recruitment?.comments || []}
      historyTarget="projects.recruitmentCommentHistory"
      onCreate={(text, files) =>
        createComment.execute({ recruitmentId: recruitment!.id, text, files })
      }
      onEdit={(text, comment) =>
        editComment.execute({ recruitmentId: recruitment!.id, timestamp: comment.timestamp, text })
      }
    />
  );
}
